import React, { useEffect, useRef, useState } from "react";
import "./InvoiceDetails.scss";
import { useParams } from "react-router-dom";
import { adminRequest } from "../../../utils/requestMethods";
import logo from "../../../assets/logo_prod.png";
import { MdArrowBack } from "react-icons/md";
import { FaPrint } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { MdHistory } from "react-icons/md";
import { FaReceipt } from "react-icons/fa";

const InvoiceDetails = () => {
  const { id } = useParams();
  const [invoice, setInvoice] = useState(null);
  const navigate = useNavigate();

  const printRef = useRef();

  const fetchInvoice = async () => {
    try {
      const response = await adminRequest.get(`/invoice/view/${id}`);

      setInvoice(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, []);

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Invoice-${invoice?.invoice_number}`,
  });
  if (!invoice) {
    return <div className="invoiceDetailsContainer">Loading...</div>;
  }

  return (
    <div className="invoiceDetailsContainer">
      <div className="pageTop">
        <div className="leftActions">
          <button className="backBtn" onClick={() => navigate(-1)}>
            <MdArrowBack />
          </button>
        </div>

        <div className="rightActions">
          <button
            className="historyBtn"
            onClick={() =>
              navigate(`/studentFees/payment/history/${invoice.uuid}`)
            }
          >
            <MdHistory />
            Payment History
          </button>

          <button
            className="receiptBtn"
            onClick={() =>
              navigate(`/studentFees/payment/receipt/${invoice.uuid}`)
            }
          >
            <FaReceipt />
            View Receipt
          </button>

          <button className="printBtn" onClick={handlePrint}>
            <FaPrint />
            Print
          </button>
        </div>
      </div>
      <div className="invoiceReceipt" ref={printRef}>
        <div className="topSerial">
          <p>
            Serial No:
            <span>{invoice.invoice_number}</span>
          </p>
        </div>

        <div className="receiptHeader">
          <div className="logoSection">
            <img src={logo} alt="college-logo" />
          </div>

          <div className="collegeDetails">
            <h2>Kantipur College of Management and Information Technology</h2>

            <p>Baneshwor, Kathmandu, Nepal</p>

            <p>Tel: 4479939</p>
          </div>
        </div>

        <div className="billTitle">
          <h3>Bill</h3>
        </div>

        <div className="invoiceMeta">
          <div className="metaRow">
            <div className="metaItem">
              <span>Name:</span>
              <p>{invoice.Student?.fullName}</p>
            </div>

            <div className="metaItem">
              <span>Semester:</span>
              <p>{invoice.semester}</p>
            </div>

            <div className="metaItem date">
              <span>Date:</span>
              <p>{invoice.invoice_date}</p>
            </div>
          </div>
        </div>

        <div className="invoiceTable">
          <table>
            <thead>
              <tr>
                <th>S.N</th>
                <th>DESCRIPTION</th>
                <th>Amount</th>
                <th>Remark</th>
              </tr>
            </thead>

            <tbody>
              {invoice.FeeInvoiceItems?.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>Rs. {item.amount}</td>
                  <td>{item.description}</td>
                </tr>
              ))}

              {invoice.discount_amount > 0 && (
                <tr>
                  <td>{invoice.FeeInvoiceItems?.length + 1}</td>
                  <td>Discount</td>
                  <td> (Rs. {invoice.discount_amount})</td>
                  <td>{invoice.discount_reason}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="totalSection">
          <p>
            Total:
            <span> Rs.{invoice.payable_amount}</span>
          </p>
        </div>

        <div className="bottomSection">
          <div className="receivedBy">
            <p>Received By</p>
          </div>

          <div className="officeSeal">
            <p>Office Seal</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetails;
